/**
 * @file 定时器函数实现
 */
import { parseParam } from '../index';
/**
 * 设置间隔调用函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const setIntervalFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let milliseconds = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let functionCalled = async () => {
      await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId, false);
    }
    return setInterval(functionCalled, milliseconds);
  }
}

/**
 * 设置延迟调用函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const setTimeoutFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let milliseconds = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let functionCalled = async () => {
      await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId, false);
    }
    return setTimeout(functionCalled, milliseconds);
  }
}

/**
 * 销毁定时器函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const clearIntervalFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let timerId = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    return clearInterval(timerId);
  }
}